import { minusSquareIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const MinusO = createIcon({
  displayName: 'MinusO',
  paths: [
    'M256 170.667c-47.104 0-85.333 38.229-85.333 85.333v512c0 47.104 38.229 85.333 85.333 85.333h512c47.104 0 85.333-38.229 85.333-85.333v-512c0-47.104-38.229-85.333-85.333-85.333h-512zM768 768h-512v-512h512v512zM384 469.333h256c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667h-256c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667z'
  ],
  canvasPaths: canvasIconPaths(minusSquareIcon)
})
